import React from "react";
import styles from "./PlaygroundOutputLoader.module.scss";

const PlaygroundOutputLoader = () => {
  return <div className={styles.loader} />;
};

export default PlaygroundOutputLoader;
